import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { useAreServicesActive } from "../../util/CommonServices";
import { ezsServiceIds } from "../../config/UserServicesList";

const DedicatedResolutionSpecialistCard = () => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const CyberActiveServices = useAreServicesActive([ezsServiceIds.businessCyberClaimSupport]);
    let CyberClaimFriendlyName;
    let CyberFriendlyPhoneNumber;
    const PartnerName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );
    const PartnerPhoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const RetailerName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerName
            ? state.configurationState.configuration.partnerConfig.retailerName
            : ""
    );
    const RetailerPhoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerPhoneNumber
            ? state.configurationState.configuration.partnerConfig.retailerPhoneNumber
            : ""
    );
    const RetailerCyberClaimPhoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerCyberClaimPhoneNumber
            ? state.configurationState.configuration.partnerConfig.retailerCyberClaimPhoneNumber
            : ""
    );
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );
    const isAVGId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2659
                ? true
                : false
            : false
    );
    const isAVGTestId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2662
                ? true
                : false
            : false
    );
    if (RetailerName && RetailerCyberClaimPhoneNumber) {
        CyberClaimFriendlyName = RetailerName;
        CyberFriendlyPhoneNumber = RetailerCyberClaimPhoneNumber;
    } else if (RetailerName && RetailerPhoneNumber) {
        CyberClaimFriendlyName = RetailerName;
        CyberFriendlyPhoneNumber = RetailerPhoneNumber;
    } else {
        CyberClaimFriendlyName = PartnerName;
        CyberFriendlyPhoneNumber = PartnerPhoneNumber;
    }

    return (
        <React.Fragment>
            {CyberActiveServices && (
                <div className="box box-border-top">
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-text">
                                <h3 className="box-title">
                                    <p>{tLang("dashboard.dedicatedResolutionSpecialistWidget.cyberTitle")}</p>
                                </h3>
                            </div>
                            <div className="box-title-icon position-right" aria-hidden="true">
                                <RenderIcons iconName="user-alt" />
                            </div>
                        </div>
                    </div>
                    <div className="box-content">
                        <p>
                            <strong>
                                {tLang("dashboard.dedicatedResolutionSpecialistWidget.cyberMainMessage", { PartenrClaimFriendlyName: CyberClaimFriendlyName })}
                            </strong>
                        </p>
                        <p>{tLang("dashboard.dedicatedResolutionSpecialistWidget.cyberMessage")}</p>
                        <br />
                        <p>
                            {tLang("dashboard.dedicatedResolutionSpecialistWidget.cyberContactText")} <strong> {CyberFriendlyPhoneNumber} </strong>
                        </p>
                    </div>
                </div>
            )}
            {!CyberActiveServices && (
                <div className="box box-border-top">
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-text">
                                <h3 className="box-title">
                                    <p>{tLang("dashboard.dedicatedResolutionSpecialistWidget.title")}</p>
                                </h3>
                            </div>
                            <div className="box-title-icon position-right" aria-hidden="true">
                                <RenderIcons iconName="user-alt" />
                            </div>
                        </div>
                    </div>
                    <div className="box-content">
                        <p>
                            <strong>{tLang("dashboard.dedicatedResolutionSpecialistWidget.mainMessage")}</strong>
                        </p>
                        <p>
                            {isAvastId || isAVGId || isAVGTestId
                                ? tLang("dashboard.dedicatedResolutionSpecialistWidget.avastMessage")
                                : tLang("dashboard.dedicatedResolutionSpecialistWidget.message")}
                        </p>
                        <p className="text-align-center">
                            <Link
                                to="/support"
                                type="button"
                                className="btn-default btn-secondary-outline bit-btn"
                                onClick={() => window.addToDataLayer({ event: "Contact Resolution Specialist" })}
                            >
                                <span className="btn-text">{tLang("dashboard.dedicatedResolutionSpecialistWidget.buttonText")}</span>
                            </Link>
                        </p>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default DedicatedResolutionSpecialistCard;
